<template>
  <div class="card floating" id="share">
    <div class="card-title">
      <div class="text">{{ $t('prompts.shareLink') }}</div>
      <button class="button button-close"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.close')"
        :title="$t('buttons.close')">
        <img src="/img/icons/other-stuff/lnr-cross.svg">
      </button>
    </div>

    <div class="card-content">
      <ul>
        <li style="display: block;">
          <p>{{ $t('permanent') }}</p>
          <div class="link-container">
            <p class="link">{{ joinLink }}</p>
            <div class="botones">
              <button class="button button-copy"
              :data-clipboard-text="joinLink"
              :aria-label="$t('buttons.copyToClipboard')"
              :title="$t('buttons.copy')">
                <p>{{ $t('buttons.copy') }}</p>
                <img src="/img/icons/Distribuidores/Share-white.svg">
              </button>
              <a class="button button-link" :href="joinLink" 
              target="_blank"
              :title="$t('buttons.link')">
                <p>{{ $t('buttons.link') }}</p>
                <img src="/img/icons/other-stuff/external-link-line-white.svg">
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Clipboard from 'clipboard';

export default {
  name: 'join-link',
  data: function () {
    return {
      link: '',
      clip: null,
    };
  },
  computed: {
    ...mapState([ 'req', 'joinLink' ]),
  },
  mounted () {
    this.clip = new Clipboard('.button-copy');
    this.clip.on('success', () => {
      this.$showSuccess(this.$t('success.linkCopied'));
    });
  },
  beforeDestroy () {
    this.setJoinLink('');
    this.clip.destroy();
  },
  methods: {
    ...mapMutations(['closeHovers', 'setJoinLink']),
  }
};
</script>